<div [ngSwitch]="structuredData.requirement">

    <div *ngSwitchCase="requirements.PROOF_OF_BIRTH">
        
        <div class="structured-data">
            <h3><strong>{{ dataTitle | translate }}</strong></h3>
            <p><strong>{{ 'STRUCTURED_DATA.NAME' | translate }}:</strong> {{ structuredData.data.isAbout?.person?.givenName }}</p>
            <p><strong>{{ 'STRUCTURED_DATA.FAMILY_NAME' | translate }}:</strong> {{ structuredData.data.isAbout?.person?.familyName }}</p>
            <p><strong>{{ 'STRUCTURED_DATA.DOB' | translate }}:</strong> {{ structuredData.data.isAbout?.person?.dateOfBirth }}</p>
            <p><strong>{{ 'STRUCTURED_DATA.POB' | translate }}:</strong> {{ structuredData.data.isAbout?.person?.placeOfBirth?.geographicName[0] }}</p>
                <!-- <a *ngIf="structuredData.data.isAbout?.person?.placeOfBirth?.geographicName"
                    [href]="structuredData.data.isAbout?.person?.placeOfBirth?.geographicIdentifier" target="_blank"
                    rel="noopener noreferrer">
                    {{ structuredData.data.isAbout?.person?.placeOfBirth?.geographicName[0] }}
                </a> -->
            
            <p><strong>{{ 'STRUCTURED_DATA.SEX' | translate }}:</strong>
                {{ ('STRUCTURED_DATA.SEX_VALUES.' + structuredData.data.isAbout?.person?.sex) | translate }}
            </p>
        </div>

    </div>

    <div *ngSwitchCase="requirements.PROOF_OF_RESIDENCE_DOMICILE">

    </div>

    <div *ngSwitchDefault>

    </div>

</div>